<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()"
        ><i class="fal fa-times-circle fa-lg"></i
      ></span>
      <div
        class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom"
      >
        <h1 class="h2">Segunda via da fatura</h1>
        <div class="btn-toolbar mb-2 mb-md-0"></div>
      </div>
      <div
        id="alert"
        class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
        :class="alert.color"
        role="alert"
        v-if="alert.message"
        ref="alert"
      >
        <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
        <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
        ><br />
        {{ alert.reason }}
      </div>
      <div class="tab-content">
        <div class="tab-pane active" id="save_invoice" role="tabpanel">
          <form name="invoice" class="needs-validation" novalidate>
            <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
              <h5><i class="fas fa-pen-nib"></i> Informações da fatura</h5>
            </div>
            <div class="row mb-2">
              <div class="col-md-6">
                <label>Cliente</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    v-model="data.customer.customerable.name"
                    readonly="readonly"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <label>Mês</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder=""
                    :value="this.$options.filters.month(data.billing_month)"
                    readonly="readonly"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <label for="due_date">Vencimento</label>
                <div class="input-group">
                  <input
                    id="due_date"
                    type="date"
                    max="9999-12-31"
                    ref="due_date"
                    class="form-control m-input"
                    v-model="data.due_date"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="alert m-alert m-alert--default col-md-12 mb-12 mt-5" role="alert">
              <h5>Opções</h5>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="data.current_fines_option"
                    id="current_fines"
                  />
                  <label class="form-check-label" for="current_fines">
                    Aplicar multas da fatura original à essa segunda via
                  </label>
                </div>
              </div>
              <!-- <div class="col-md-12">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="data.keep_early_payment_discount"
                    id="keep_discounts"
                  />
                  <label class="form-check-label" for="keep_discounts">
                    Manter descontos de pagamento antecipado
                  </label>
                </div>
              </div> -->
            </div>
            <hr class="row mt-5 mb-3" />
            <div class="row">
              <div class="col-md-12 text-right">
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.due_date.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="!checkValidDueDate()"
                    >O <b>vencimento</b> precisa ser uma data futura</a
                  >
                </p>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-12 text-right">
                <button
                  @click.prevent="confirmDuplicate()"
                  class="btn"
                  :class="{
                    'btn-metal': !formIsValid,
                    'btn-focus': formIsValid,
                  }"
                  :disabled="!formIsValid"
                >
                  <i class="fas fa-save" v-if="formIsValid"></i>
                  <i class="fas fa-exclamation-triangle" v-else></i>
                  Gerar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { baseApiUrl } from '@/global';
import axios from 'axios';
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin.js';

export default {
  name: 'InvoiceModal',
  mixins: [returnMessageMixin, validationFilterValueMixin],
  data() {
    const data = this.$store.state.selectedInvoice;
    data.current_fines_option = true;
    data.ignore_due_email = false;
    data.ignore_canceled_email = false;
    data.keep_early_payment_discount = false;
    return {
      data,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    closeThis() {
      this.$store.state.showInvoiceDuplicate = null;
      this.$store.state.selectedInvoice = null;
    },
    checkValidDueDate() {
      return moment(this.data.due_date).isAfter(moment());
    },
    confirmDuplicate(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar segunda via dessa fatura?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Enviar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.duplicateInvoice();
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Segunda via não foi enviada!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    duplicateInvoice() {
      const requestData = {
        griffinInvoiceId: this.data.id,
        ignore_canceled_email: this.data.ignore_canceled_email,
        ignore_due_email: this.data.ignore_due_email,
        current_fines_option: this.data.current_fines_option,
        keep_early_payment_discount: this.data.keep_early_payment_discount,
        due_date: this.data.due_date,
      };
      const url = `${baseApiUrl}/v1/invoice/duplicate`;
      axios
        .post(url, requestData)
        .then((res) => {
          this.logMessage(res);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  computed: {
    invoiceId() {
      return this.$store.state.showInvoiceDuplicate;
    },
    formIsValid() {
      if (this.checkValidDueDate()) {
        return true;
      }
      return false;
    },
  },
};
</script>
